import identity from "lodash/identity"
import { Fragment, useState } from "react"
import { Field } from "react-final-form"

import { Button } from "@trueskin-web/components"
import { InputControl } from "@trueskin-web/components"
import {
  composeValidators,
  mustBeValidStreetAddress,
  required,
} from "@trueskin-web/functions"
import { Trans, useTranslation } from "@trueskin-web/translations"

const StreetAndBuilding = ({ fieldName, type }) => {
  const { t } = useTranslation()

  const [showAdditionalAddress, setShowAdditionalAddress] = useState(false)

  return (
    <Fragment>
      <Field
        data-testid="web-portal-shipping-form-street"
        name={fieldName}
        component={InputControl}
        validate={composeValidators(
          (value) =>
            required(value, t("Generic.errors.streetAndBuildingRequired")),
          mustBeValidStreetAddress("country")
        )}
        format={(value) => (value || "").replace(",", ".")}
        parse={identity}
        required
        message={
          !showAdditionalAddress ? (
            <Button
              variant="link"
              size="sm"
              onClick={() => setShowAdditionalAddress(true)}
              sx={{ p: 0, color: "primary", letterSpacing: "initial" }}
            >
              <Trans i18nKey="Start.Questionnaire.addAdditionalAddress" />
            </Button>
          ) : null
        }
        label={t("Start.Questionnaire.streetWithNumber")}
        placeholder={t("Start.Questionnaire.streetWithNumber")}
        rounded
      />

      <Field
        name={`${type}.additionalAddress`}
        label={t("Start.Questionnaire.additionalAddress")}
        placeholder={t("Start.Questionnaire.additionalAddress")}
        parse={identity}
        rounded
      >
        {(props) => {
          if (props.input.value || showAdditionalAddress) {
            return <InputControl {...props} />
          }
          return null
        }}
      </Field>
    </Fragment>
  )
}

export default StreetAndBuilding
